<template lang="pug">
  .component-vehicle-list.row.column
    vehicle-list-form(@filterVehicles="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'

  import StatisticsCard7 from "components/structure/ui/StatisticsCard7";
  import VehicleListForm from "components/structure/ui/filters/VehicleListForm";
  import BaseList from "./BaseList";
  import {mapState} from 'vuex'

  export default {
    name: "VehicleSlotList",
    components: {
      BaseList,
      VehicleListForm,
      StatisticsCard7,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Vehicle.vue'),
        reports: null,
        search: null
      }
    },
    computed: {
     ...mapState({
      configuration: state => state.configuration,
    }),
    },
    methods: {
      setSearch(search) {
        console.log(search)
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.vehicles.list(page, resultsPerPage).all(search, (items) => {
          if (search && search.active !== null) {

            items.items.forEach((item, index) => {
              if (search.active && item.slot_disabled === 1) {
              } else if (search.active && item.slot_disabled === 0) {
                items.items.splice(index, 1)
              }
            })
          }
          callback(items)
        })
      },
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleList.vue?8e3ef99c